<template>
    <div class="macro_data_wrap">
        <GobackBar :stokeType="stokeType"></GobackBar>
        <div class="flex-start-between macro_data_content">
            <!-- 左侧导航栏列表 -->
            <div class="macro_menu">
                <div class="menu_title">宏观数据</div>
                <div @click="getMacroData(item)" v-for="item in menuList" class="mouse-hover" :class="{'active_menu':item.id == menuId}" :key="item.id">{{item.name}}</div>
            </div>
            <!-- 右侧宏观数据列表 -->
            <div class="macro_list">
                <div class="flex-between">
                    <div class="macro_list_title ">{{menuName}}</div>
                    <div class="flex-center">
                        <el-input prefix-icon="el-icon-search" placeholder="输入数据关键字搜索"></el-input>
                        <el-button type="primary">确定</el-button>
                    </div>
                </div>
                <!-- 宏观数据主体列表内容 -->
                <div class="main_content">
                    <div class="flex-center" v-for="item in macroDataList" :key="item.id">
                        <i v-if="item.layout == 1" class="iconfont icon-dot first_data">{{item.name}}</i>
                        <div class="two_data" v-else-if="item.layout == 4">&nbsp;&nbsp;&nbsp;&nbsp;-{{item.name}}</div>
                        <div v-else class="three_data" @click="getPriceTable(item)">{{item.name}}</div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="dialogName" :visible.sync="priceDialogVisible" center width="65%">
            <div class="dialog_content">
                <div class="top_tips pl20">数据示例</div>
                <el-table :data="priceData"  :cell-style="{textAlign:'center',padding:'5px 0px'}"  stripe  :header-cell-style="$core.table_header">
                    <el-table-column v-for="item in priceDataColumn" :key="item.label" :prop="item.label" :label="item.name"></el-table-column>
                </el-table>
                <div class="top_tips pl20 mat20">选择时间区间</div>
                <div class="time_select">
                    <el-date-picker  range-separator="至" start-placeholder="开始日期" :picker-options="pickerOptions"  end-placeholder="结束日期" unlink-panels type="daterange" value-format="yyyy-MM-dd" v-model="timeRangeValue"></el-date-picker>
                </div>
                <div class="flex-around mat20">
                    <el-button type="primary" @click="downloadFile">数据下载</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { macro, macroMenu, priceExample } from '../../utils/api';

export default {
    data() {
        return {
            stokeType: '宏观数据',
            macroDataList: [],
            menuList: [],
            menuId: '',
            menuName: '',
            dialogName: '',
            dialogId: '',
            priceDialogVisible: false,
                priceData:[],
                priceDataColumn:[],
                timeRangeValue:[],
                pickerOptions:{
                    disabledDate(data){
                        return data && data.valueOf() >= new Date()
                    }
                },
            }
        },
        created(){
            this.getMacroMenu()
        },
        methods:{
            // 下载数据
            downloadFile(){
                if(!this.timeRangeValue.length) return this.$message.warning('请选择时间范围！！')
                const loading = this.$loading({
                    lock:true,
                    text:'拼命加载中..',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                this.$core.downloadFileData('GET',`${this.$config.BASE_URL}/macro/download?startDate=${this.timeRangeValue[0]}&endDate=${this.timeRangeValue[1]}&id=${this.dialogId}`).then(res => {
                    loading.close()
                }).catch(err => {
                    loading.close()
                })
            },

            //获取企业商品价格指数
            getPriceTable(obj){
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                priceExample({id:obj.id}).then(res => {
                    this.dialogId = obj.id
                    this.dialogName = obj.name
                    this.priceDialogVisible = true,
                    this.priceDataColumn = res.nameList
                    this.priceData = res.dataList
                    loading.close();
                }).catch(err => {
                    this.$message.warning('响应超时！！')
                    loading.close();
                })
            },

            // 获取宏观数据目录
            getMacroMenu(){
                macroMenu().then(res => {
                    this.menuList = res.data
                    this.getMacroData(res.data[0])
                }).catch(err => {})
            },

            //获取宏观数据列表内容
            getMacroData(val){
                macro({ id:val.id }).then(res => {
                    this.menuName = val.name
                    this.menuId = val.id
                    let allData = []
                    let Aciveindex=[]
                    res.data.map(item => {
                        allData.push({
                            id:item.id,
                            name:item.name,
                            layout:1,
                        })
                        //判断是否有第二级别目录
                        if(Boolean(item.children.length)){
                            item.children.map(subItem => {
                              allData.push({
                                  id:subItem.id,
                                  name:subItem.name,
                                  layout: Boolean(subItem.children.length) ? 4 : 2,
                              })
                              // 判断是否有第三级目录
                              if(Boolean(subItem.children.length)){
                                  subItem.children.map(threeItem => {
                                      allData.push({
                                          id:threeItem.id,
                                          name:threeItem.name,
                                          layout:3,
                                      }),
                                      Aciveindex.push({
                                          id:threeItem.id
                                      })
                                  })
                              }
                            })
                        }
                 })
                   this.macroDataList = allData;
                   this.timeRangeValue = []
                }).catch(err => { });
            }
        },
    }
</script>
<style lang='scss' scoped>
/deep/.el-dialog__title{
    font-size: 25px;
    font-weight: bold;
    color: #271B63;
}
.time_select{
    width: 500px;
}
.flex_column{
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}
.macro_data_content{
    width: 100vw;
    box-sizing: border-box;
    padding: 20px 40px;
    .macro_menu{
        width: 15%;
        min-height: calc(100vh - 50px);
        background: white;
        box-sizing: border-box;
        padding: 15px 0px;
        box-shadow: 0px 3px 6px #888888;
        color: #271B63;

        >div{
            padding: 7px 0px 7px 55px;
            &:hover{
                background: rgba(244,242,255,0.5900);
            }
        }
        .menu_title{
            font-size: 22px;
            font-weight: bold;
            margin: 15px 0px;
            padding: 0px 40px;
        }
        .active_menu{
            background: rgba(244,242,255,0.5900);

        }
    }
    .macro_list{
        width: 83%;
        .macro_list_title{
            font-size: 22px;
            color: #271B63;
            font-weight: bold;
        }
        .main_content{
            @extend .flex_column;
            width: 100%;
            margin-top: 25px;
            padding: 40px 70px;
            box-sizing: border-box;
            background: white;
            border-radius: 10px;
            max-height: calc(100vh - 65px);
            overflow: auto;
            color: #333;
            line-height: 1.7;
            .flex-center{
                >div{
                    width: 450px;
                }
            }
            .first_data{
                font-size: 20px;
                font-weight: bold;
                margin: 10px 0px;
            }
            .two_data{
                font-weight: bold;
                margin: 5px 0px;
                font-family: '黑体';
            }
            .three_data{
                line-height: 2;
                text-decoration: underline;
                margin-left: 25px;
                font-family: '微软雅黑';
                &:hover{
                    color: #271B63;
                    cursor: pointer;
                }
            }
        }

    }
}
.macro_data_wrap{
    width: 100vw;
    min-height: 100vh;
    background: #F7F7F7;
}
</style>
